export const p1 = {
  Explanation: '语音讲解',
}



// WEBPACK FOOTER //
// ./src/common/lang/zh/p1.js